import { dmpConnectApi } from '@/core/api/dmp-connect'

export const {
  useGetDmpConnectDcParameterQuery,
  useGetDmpConnectBuildDownloadQuery,
  useLazyGetDmpConnectBuildDownloadQuery,
  useGetDmpConnectBuildVersionQuery,
} = dmpConnectApi
